'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { LAYER_ITEMS, TRACKING_PREFIX } from './constants'
import { IMAGE_GRADIENT_CLASS } from './ui'

type LayerCopy = {
  label: string
  attrs: [string, string]
  tagline: string
  materials: string
}

export function LayerSection() {
  const t = useTranslations('do_thu_dong_hardcode.layers')
  const items = t.raw('items') as LayerCopy[]

  return (
    <section className='bg-neutral-800'>
      {/* Mobile vuốt ngang (card 260px), desktop 3 cột cố định nên không cuộn */}
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          breakpoints: { '(min-width: 1024px)': { active: false } },
        }}
        plugins={[
          Autoplay({
            delay: 4000,
            stopOnInteraction: false,
            breakpoints: { '(min-width: 1024px)': { active: false } },
          }),
        ]}
      >
        <CarouselContent className='ml-0 lg:grid lg:grid-cols-3'>
          {items.map((item, index) => (
            <CarouselItem
              key={item.label}
              className='basis-[260px] !cursor-default pl-0 lg:basis-auto'
            >
              <div className='relative flex aspect-[260/390] flex-col justify-end gap-3 overflow-hidden bg-neutral-100 px-4 py-6 lg:aspect-[640/960] lg:gap-5 lg:p-16'>
                <Image
                  src={ImageHelper.getImageUrl(
                    LAYER_ITEMS[index].image,
                    '',
                    1280
                  )}
                  alt={item.tagline}
                  fill
                  sizes='(min-width: 1024px) 33vw, 260px'
                  className='object-cover'
                />
                <div className={IMAGE_GRADIENT_CLASS} />

                <p className='relative font-sans text-sm font-medium leading-5 text-white lg:text-base lg:leading-6'>
                  {item.label}
                </p>
                <ul className='relative flex gap-3 lg:gap-6'>
                  {item.attrs.map((attr, attrIndex) => (
                    <li key={attr} className='flex items-center gap-2'>
                      <Image
                        // Không resize qua N7 (ép JPEG → mất nền trong suốt)
                        src={ImageHelper.getImageUrlCdn(
                          LAYER_ITEMS[index].icons[attrIndex]
                        )}
                        alt=''
                        width={28}
                        height={28}
                        className='size-7'
                      />
                      <span className='font-sans text-xs leading-4 text-white lg:text-sm lg:leading-5'>
                        {attr}
                      </span>
                    </li>
                  ))}
                </ul>
                <p className='relative font-criteria text-2xl font-semibold leading-[35px] tracking-[-0.02em] text-neutral-200 lg:text-4xl lg:leading-[47px]'>
                  {item.tagline}
                </p>
                <p className='relative font-sans text-xs leading-4 text-white lg:text-sm lg:leading-5'>
                  {item.materials}
                </p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>

        <CarouselNext
          hideIfEnd
          variant='white'
          className='absolute right-[34px] top-1/2 size-12 -translate-y-1/2 rounded-full border-none bg-white text-black shadow-[0_4px_9px_rgba(0,0,0,0.12)] hover:bg-white lg:hidden'
          ga-tracking-value={`${TRACKING_PREFIX}__layer__next`}
        />
      </Carousel>
    </section>
  )
}
